export const SHARED_ROUTES: Record<string, string> = {
  PRACTICE_LANDING: '/practice',
  LANDING_PAGE: '/intro/landing-page',
  INVITATION_AUTHENTICATION: '/intro/invitation-authentication',
  LANDING_PROFESSIONAL_SELECT: '/intro/landing-professional-select',
  LANDING_PRACTICE: '/intro/landing-practice',
  LANDING_SOMMEIL_BLIGNY: '/sommeil/landing-bligny',
  LANDING_ETP_SOMMEIL: '/sommeil/landing-etp',
  LANDING_PROM_ARS: '/prom-ars/landing',
  PATIENT_INFORMATION: '/intro/patient-information',
  PATIENT_ADMINISTRATIVE: '/intro/patient-administrative',
  PATIENT_CONTACT: '/intro/patient-contact',
  PATIENT_ADDRESS: '/intro/patient-address',
  PATIENT_PROFESSION: '/intro/patient-profession',
  SELF_IDENTIFICATION_QUESTION: '/intro/self-identification-question',
  CONSULTATION_TIME: '/intro/consultation-time',
  DIRECT_CONFIRMATION: '/direct-confirmation',
  ADDITIONAL_DOCUMENT_UPLOAD: '/additional-document-upload',
  ERROR: '/error',
} as const;

export const MED_G_ROUTES: Record<string, string> = {
  WHY_PREPARE_CONSULTATION: '/intro/why-prepare-consultation',
  QUESTIONNAIRE_STEPS_OVERVIEW: '/intro/questionnaire-steps-overview',
  NOTICE: '/intro/notice',
  INTRODUCTION: '/questionnaire/introduction',
  CHECKLIST: '/checklist',
  RESEARCH_CONSENT: '/research-consent',
  CONFIRMATION: '/confirmation',
  LOGIN: '/login',
} as const;

export const SOMMEIL_ROUTES: Record<string, string> = {
  INTRO_1: '/sommeil/intro1',
  INTRO_2: '/sommeil/intro2',
} as const;

export const SOMMEIL_BLIGNY_ROUTES: Record<string, string> = {
  ACCUEIL: '/sommeil-bligny/accueil',
  RECHERCHE: '/sommeil-bligny/recherche',
} as const;

export const MON_BILAN_PREVENTION_ROUTES: Record<string, string> = {
  INTRO_1: '/mon-bilan-prevention/intro1',
  INTRO_2: '/mon-bilan-prevention/intro2',
  INELIGIBLE: '/mon-bilan-prevention/ineligible',
};
